/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from 'react';
import {connect, Provider} from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import TopNavigationBar from './components/widgets/TopNavigationBar/TopNavigationBar';
import  MessageArea from "./components/widgets/MessageBox/MessageArea";
import Routes from './routes';
import {IntlProvider} from 'react-intl';

const mapStateToProps = (state) => {
    return {locale: state.i18n.locale, messages: state.i18n.messages};
};
export const ConnectedIntlProvider = connect(mapStateToProps)(IntlProvider);

class App extends Component {
    render() {
        return (
            <Provider store={this.props.store}>
                <ConnectedIntlProvider>
                    <ConnectedRouter history={this.props.history}>
                        <div id="main-container">
                            <TopNavigationBar/>
                            <MessageArea/>
                            <Routes/>
                        </div>
                    </ConnectedRouter>
                </ConnectedIntlProvider>
            </Provider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js